<pda-base>
    <div class="pda-about pda-section full-height">
         <div class="pda-about-section">
             <div class="pda-about-section-title-container">
                 <h2 class="pda-title">
                     <span class="pda-title-1 text-shadow">Sobre</span>
                     <span class="pda-title-2 text-shadow">&nbsp;Nosotros</span>
                 </h2>
             </div>
             <!-- <div class="pda-about-section-subtitle">
                 <h3 class="pda-about-subtitle">Allegra Pole Dance</h3>
             </div> -->
             <div class="pda-about-section-description">
                <p>
                    Escuela de pole dance y sus derivados basados en la enseñanza de calidad para formar atletas de nivel internacional promocionando nuestras disciplinas como una rama fusi&oacute;n de la danza y el deporte de alto rendimiento.
                </p>
             </div>
             <div class="pda-about-section-description">
              <pda-video-about></pda-video-about>
              <!-- <video class="pda-about-setion-description__video">
                <source src="assets/videos/about-us.mp4" type="video/mp4">
              </video> -->
             </div>
         </div>
    </div>
 </pda-base>
